import { render, staticRenderFns } from "./FormRegister.vue?vue&type=template&id=66531366&"
import script from "./FormRegister.vue?vue&type=script&lang=js&"
export * from "./FormRegister.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/guave/madamesumcontao/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66531366')) {
      api.createRecord('66531366', component.options)
    } else {
      api.reload('66531366', component.options)
    }
    module.hot.accept("./FormRegister.vue?vue&type=template&id=66531366&", function () {
      api.rerender('66531366', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/madamesum/js/components/FormRegister.vue"
export default component.exports